/*
  An library for doing eliptic curve encryption using a BCH public key for
  encrypting data, and a BCH private key for decrypting the data.
*/
'use strict';

var _regeneratorRuntime = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/trout/static/chat.fullstack.cash-v2/node_modules/@babel/runtime/helpers/createClass.js");

var eccrypto = require('eccrypto-js');

var wif = require('wif');

var _this;

var Encrypt = /*#__PURE__*/function () {
  function Encrypt() {
    _classCallCheck(this, Encrypt);

    _this = this;
    this.eccrypto = eccrypto;
    this.wif = wif;
  } // Encrypt a file with the public key.
  // pubKey: public key in hex-string format
  // file: binary file in hex-string format
  // Output: A hex-string representing the encrypted file


  _createClass(Encrypt, [{
    key: "encryptFile",
    value: function () {
      var _encryptFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pubKey, file) {
        var pubKeyBuf, bufferedFile, structuredEj, encryptedEj, encryptedStr;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(!pubKey || typeof pubKey !== 'string')) {
                  _context.next = 3;
                  break;
                }

                throw new Error('pubkey must be a hex string');

              case 3:
                if (!(!file || typeof file !== 'string')) {
                  _context.next = 5;
                  break;
                }

                throw new Error('file must be a hex string');

              case 5:
                pubKeyBuf = Buffer.from(pubKey, 'hex');
                bufferedFile = Buffer.from(file, 'hex');
                _context.next = 9;
                return _this.eccrypto.encrypt(pubKeyBuf, bufferedFile);

              case 9:
                structuredEj = _context.sent;
                // console.log(`structuredEj: ${JSON.stringify(structuredEj, null, 2)}`)
                // Serialize the encrypted data object
                encryptedEj = Buffer.concat([structuredEj.ephemPublicKey, structuredEj.iv, structuredEj.ciphertext, structuredEj.mac]);
                encryptedStr = encryptedEj.toString('hex');
                return _context.abrupt("return", encryptedStr);

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                console.error('Error in encryption.js/encryptFile()');
                throw _context.t0;

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 15]]);
      }));

      function encryptFile(_x, _x2) {
        return _encryptFile.apply(this, arguments);
      }

      return encryptFile;
    }() // Decrypt a file with the private key.
    // privKey: private key in hex-string format
    // encryptedFile: encrypted file in hex-string format
    // Output: Decrypted file in hex-string format

  }, {
    key: "decryptFile",
    value: function () {
      var _decryptFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(privKey, encryptedFile) {
        var privKeyBuf, encryptedBuff, structData, fileBuf, decryptedStr;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(!privKey || typeof privKey !== 'string')) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('privKey must be a string');

              case 3:
                if (!(privKey.length !== 52)) {
                  _context2.next = 5;
                  break;
                }

                throw new Error('privKey must be a WIF format');

              case 5:
                if (!(!encryptedFile || typeof encryptedFile !== 'string')) {
                  _context2.next = 7;
                  break;
                }

                throw new Error('encryptedFile must be a hex string');

              case 7:
                _context2.next = 9;
                return _this.wif.decode(privKey).privateKey;

              case 9:
                privKeyBuf = _context2.sent;
                // Convert the hex encoded file to a buffer
                encryptedBuff = Buffer.from(encryptedFile, 'hex'); // Convert the bufer into a structured object.

                _context2.next = 13;
                return _this.convertToEncryptStruct(encryptedBuff);

              case 13:
                structData = _context2.sent;
                _context2.next = 16;
                return _this.eccrypto.decrypt(privKeyBuf, structData);

              case 16:
                fileBuf = _context2.sent;
                // Convert buffer data into a hex string
                decryptedStr = fileBuf.toString('hex');
                return _context2.abrupt("return", decryptedStr);

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](0);
                console.error('Error in encryption.js/decryptFile()');
                throw _context2.t0;

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 21]]);
      }));

      function decryptFile(_x3, _x4) {
        return _decryptFile.apply(this, arguments);
      }

      return decryptFile;
    }() // Converts a serialized buffer containing encrypted data into an object
    // that can interpreted by the eccryptoJS library.

  }, {
    key: "convertToEncryptStruct",
    value: function convertToEncryptStruct(encbuf) {
      try {
        // Validate Input
        if (!encbuf) {
          throw new Error('input must be a buffer');
        }

        var offset = 0;
        var tagLength = 32;
        var pub;

        switch (encbuf[0]) {
          case 4:
            pub = encbuf.slice(0, 65);
            break;

          case 3:
          case 2:
            pub = encbuf.slice(0, 33);
            break;

          default:
            throw new Error("Invalid type: ".concat(encbuf[0]));
        }

        offset += pub.length;
        var c = encbuf.slice(offset, encbuf.length - tagLength);
        var ivbuf = c.slice(0, 128 / 8);
        var ctbuf = c.slice(128 / 8);
        var d = encbuf.slice(encbuf.length - tagLength, encbuf.length);
        return {
          iv: ivbuf,
          ephemPublicKey: pub,
          ciphertext: ctbuf,
          mac: d
        };
      } catch (err) {
        console.error('Error in encryption.js/convertToEncryptStruct()');
        throw err;
      }
    }
  }]);

  return Encrypt;
}();

module.exports = Encrypt;